/**
 * Utility for saving and restoring Load More state in sessionStorage
 * State is saved based on: page ID (body[data-id]), element type (type-*), and element ID (.id-*)
 */

var getStorageKey = function (elementType, elementId) {
	var pageId = jQuery('body').attr('data-id') || 'default'
	return 'loadmore_' + pageId + '_' + elementType + '_' + elementId
}

var getElementId = function ($element) {
	// Find the closest .col element with .id-* class
	var $col = $element.closest('.col')
	if ($col.length === 0) {
		return null
	}
	// Find the class that starts with 'id-'
	var classList = $col[0].classList
	for (var i = 0; i < classList.length; i++) {
		var className = classList[i]
		if (className.indexOf('id-') === 0) {
			return className
		}
	}
	return null
}

var getElementType = function ($element) {
	// Find the closest .col element with type-* class
	var $col = $element.closest('.col')
	if ($col.length === 0) {
		return null
	}
	// Check for common grid types
	var types = ['type-thumbnailgrid', 'type-elementgrid', 'type-productsgrid', 'type-news']
	for (var i = 0; i < types.length; i++) {
		if ($col.hasClass(types[i])) {
			return types[i]
		}
	}
	return null
}

var saveLoadMoreState = function (elementType, elementId, state) {
	if (!elementType || !elementId) {
		return
	}
	var key = getStorageKey(elementType, elementId)
	try {
		sessionStorage.setItem(key, JSON.stringify(state))
	} catch (e) {
		// sessionStorage might not be available (private browsing, etc.)
		console.warn('Could not save load more state:', e)
	}
}

var getLoadMoreState = function (elementType, elementId) {
	if (!elementType || !elementId) {
		return null
	}
	var key = getStorageKey(elementType, elementId)
	try {
		var stateStr = sessionStorage.getItem(key)

		if (stateStr) {
			var parsed = JSON.parse(stateStr)

			return parsed
		} else {
		}
	} catch (e) {
		console.warn('[restoreLoadMore] Could not retrieve load more state:', e)
	}
	return null
}

var clearLoadMoreState = function (elementType, elementId) {
	if (!elementType || !elementId) {
		return
	}
	var key = getStorageKey(elementType, elementId)
	try {
		sessionStorage.removeItem(key)
	} catch (e) {
		console.warn('Could not clear load more state:', e)
	}
}

var isRememberEnabled = function () {
	if (typeof window === 'undefined' || typeof window.layData === 'undefined') {
		return true // default: enabled for backward compatibility
	}
	var val = window.layData.loadmore_remember
	return val === 'on' || val === true || val === 1 || val === '1'
}

var restoreLoadMore = {
	getElementId: getElementId,
	getElementType: getElementType,
	saveLoadMoreState: saveLoadMoreState,
	getLoadMoreState: getLoadMoreState,
	clearLoadMoreState: clearLoadMoreState,
	isRememberEnabled: isRememberEnabled,
}

export default restoreLoadMore
